/* eslint-disable global-require */
import MainHeader from '../components/mainHeader';
import CookieNotice from '../components/cookieNotice';
import Navbar from '../components/navbar';

const commonObject = {};

export default {
  init() {
    require('svg4everybody')({
      polyfill: true, // Force inline SVG
    });

    commonObject.navbar = new Navbar(this);

    if (!document.body.classList.contains('template-cookies')) {
      commonObject.cookieNotice = new CookieNotice(this);
    }

    commonObject.mainHeader = new MainHeader(this);
  },

  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js